<template>
    <b-modal title="হোল্ডিং" no-close-on-backdrop hide-footer size="xl" v-model="largeModal" @ok="largeModal = false">
        <form @submit.prevent="AddHolding">
            <div>
                <div  class="form-group row">
                    <label  class="col-sm-2 col-form-label">মোবাইল নম্বর</label>
                    <div class="col-sm-3">
                        <input type="text" disabled v-validate="'required|numeric'" v-model="user.mobile_number" class="form-control" name="phone" placeholder="মোবাইল নম্বর">
                    </div>
                    <div class="col-sm-2"></div>
                    <label  class="col-sm-2 col-form-label">এন.আই.ডি নম্বর</label>
                    <div class="col-sm-3">
                        <input type="text" disabled v-validate="'required|numeric'" v-model="user.nid" class="form-control" name="nid" placeholder="এন.আই.ডি নম্বর">
                    </div>
                </div>
                <div  class="form-group row">
                    <label  class="col-sm-2 col-form-label">নাম</label>
                    <div class="col-sm-3">
                        <input name="Name" disabled v-validate="'required'"   type="text"  v-model="user.name" class="form-control"  placeholder="নাম">
                    </div>
                    <div class="col-sm-2"></div>
                    <label class="col-sm-2 col-form-label">জন্ম তারিখ</label>
                    <div class="col-sm-3">
                        <input type="date" disabled v-model="user.birthday" class="form-control"  placeholder="জন্ম তারিখ">
                    </div>
                </div>
                <div v-if="$user.type==1"  class="form-group row">
                    <label for="bn_name" class="col-sm-2 col-form-label">হোল্ডিং নম্বর (বাংলা)</label>
                    <div class="col-sm-3">
                        <input name="bn_name" v-validate="'required'" v-model="holdingForm.bn_name" class="form-control"  >
                        <p  v-show="errors.has('bn_name')" style="color:red">* {{ errors.first('bn_name') }}</p>
                    </div>
                    <div class="col-sm-2"></div>
                    <label for="en_name" class="col-sm-2 col-form-label">হোল্ডিং নম্বর (ইংরেজিতে) </label>
                    <div class="col-sm-3">
                        <input name="en_name"  v-validate="'required'" v-model="holdingForm.en_name" class="form-control"  >
                        <p  v-show="errors.has('en_name')" style="color:red">* {{ errors.first('en_name') }}</p>
                    </div>
                </div>
                <div  class="form-group row">
                    <label for="home_name" class="col-sm-2 col-form-label">বাসার নাম </label>
                    <div class="col-sm-3">
                        <input name="home_name"  v-validate="'required'" v-model="holdingForm.home_name" class="form-control"  >
                        <p  v-show="errors.has('home_name')" style="color:red">* {{ errors.first('home_name') }}</p>
                    </div>
                    <div class="col-sm-2"></div>
                    <label for="address" class="col-sm-2 col-form-label"> ঠিকানা </label>
                    <div class="col-sm-3">
                        <input name="address"  v-validate="'required'" v-model="holdingForm.address" class="form-control" >
                        <p  v-show="errors.has('address')" style="color:red">* {{ errors.first('address') }}</p>
                    </div>
                </div>
                <div  class="form-group row">
                    <label for="owner_name" class="col-sm-2 col-form-label">মালিকের নাম </label>
                    <div class="col-sm-3">
                        <input name="owner_name"  v-validate="'required'" v-model="holdingForm.owner_name" class="form-control"  >
                        <p  v-show="errors.has('owner_name')" style="color:red">* {{ errors.first('owner_name') }}</p>
                    </div>
                    <div class="col-sm-2"></div>
                    <label for="word_no" class="col-sm-2 col-form-label ">ওয়ার্ড </label>
                    <div class="col-sm-3">
                        <div class="input-group">
                            <select  name="word_no" v-model="holdingForm.word_no"  class="form-control" >
                                <option value="">ওয়ার্ড সিলেক্ট করুন</option>
                                <option v-for="(ward,key) in wards" :key="key" :value="ward.id" >{{ ward.ward_name_bng}}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div v-if="$user.type==1" class="form-group row">
                    <label for="avatar" class="col-sm-2 col-form-label">অনুমোদন ডকুমেন্ট </label>
                    <div class="col-sm-3">
                        <input name="avatar" type="file" @change="onAvatarChange"  v-validate="'required'"  class="form-control"  >
                        <p v-show="check"  style="color:red">* File is required</p>
                    </div>
                    <div class="col-sm-2"></div>
                    <label for="approve" class="col-sm-2 col-form-label ">স্ট্যাটাস</label>
                    <b-form-group>
                        <div class="col-sm-3">
                            <b-form-radio v-model="selected"  name="status" value="1">অনুমোদিত </b-form-radio>
                            <b-form-radio v-model="selected"  name="status" value="0">অননুমোদিত </b-form-radio>
                        </div>
                    </b-form-group>
                </div>
                <div class="form-group row">
                    <div class="col-sm-12">
                        <input type="submit" value="submit" v-if="!addLoader"  class="btn btn-primary pull-right">
                        <button v-if="!addLoader" @click.prevent="close" class="btn btn-success pull-right" style="margin-right:5px;">Close</button>
                        <button v-if="addLoader" class="btn btn-primary pull-right" type="button" disabled>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Submitting...
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </b-modal>
</template>

<script>

    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
    Vue.use(VeeValidate);
    import { mapState,mapGetters } from "vuex"
    import axios from 'axios'
    export default {
        data(){
            return{
                largeModal:false,
                addLoader: false,
                selected:'',
                check:false,
                servererrors:{},
                user:{
                    id:'',
                    name:'',
                    nid:'',
                    mobile_number:'',
                    birthday:'',
                },
                holdingForm:{
                    bn_name:'',
                    en_name:'',
                    word_no:'',
                    address:'',
                    home_name:'',
                    owner_name:'',
                    status:'',
                    avatar:''

                }
            }
        },

        computed:{
            ...mapGetters(['wards','modal'])
        },
        mounted(){
            this.wardLists()
        },
        methods:{
            onAvatarChange(e) {
                var fileReader = new FileReader()
                fileReader.readAsDataURL(e.target.files[0])
                fileReader.onload = e => {
                    this.holdingForm.avatar = e.target.result
                }
                this.check = false
                // this.url = URL.createObjectURL(e.target.files[0])
            },
            openModal(data){
                this.largeModal = true
                this.user = data.user

            },
            close(){
                this.largeModal = false
            },
            AddHolding(){
                if(this.$user.type!=1){
                    this.holdingForm.avatar =true
                }
                this.check = true
                this.$validator.validateAll().then(results => {
                    if (results && this.holdingForm.avatar){
                        this.check = false
                        this.addLoader = true
                        this.holdingForm.user_id = this.user.id
                        this.holdingForm.status = this.selected
                        this.$store.dispatch('ADD_HOLDING',this.holdingForm)
                            .then(v=>{
                                this.addLoader = false
                                this.holdingForm.bn_name =""
                                this.holdingForm.en_name=""
                                this.holdingForm.owner_name=""
                                this.holdingForm.home_name=""
                                this.holdingForm.word_no =""
                                this.holdingForm.status = ''
                                this.largeModal = false
                            })
                            .catch(error=>{
                                alert("ok")
                                this.addLoader=false;
                                this.servererrors = error.response;
                            });
                    }
                })

            },
            wardLists(){
                this.$store.dispatch('WARD_LIST')
            }
        }

    }
</script>
<style scoped lang="scss">

</style>